/**
 * Shared Constants
 * 
 * Centralized constants used throughout the application.
 * This ensures consistency and makes it easier to maintain.
 */

/**
 * List of valid Fachbereiche (departments) that helpers can be assigned to.
 * This list must match the backend VALID_FACHBEREICHE array.
 */
export const FACHBEREICHE = [
  'Bewirtung',
  'Helfermanagement',
  'Kuchenverkauf',
  'Laufstrecke',
  'Rad Fitness',
  'Rad Römerman',
  'Römerkids',
  'Schwimmen Fitness',
  'Schwimmen Römerman',
  'Startnummern',
  'Wechselzone',
  'Zielverpflegung'
] as const;

// Export as constant
export const API_BASE_URL = window._env_.API_URL;

/**
 * Valid Rückmeldung (feedback) options for helpers
 */
export const VALID_RUECKMELDUNGEN = [
  'Zur Kenntnis genommen',
  'In Bearbeitung',
  'Warte auf Helferrückmeldung',
  'Bestätigt',
  'Passt nicht'
] as const;

export type Fachbereich = typeof FACHBEREICHE[number];
export type Rueckmeldung = typeof VALID_RUECKMELDUNGEN[number];

